"use strict";
module.exports = {
    'v1.email.sendEmail': 'mail',
    'v1.email.sendEmailWithSES': 'mail',
    'v1.email.resendEmail': 'mail',
    'v1.email.upsert': 'mail',
    'v1.email.upsertWhenEmpty': 'mail',
    'v1.email.updateWhenEmpty': 'mail',
    'v1.email.update': 'mail',
    'v1.emailTemplateConfig.upsert': 'mail',
    'v1.emailTemplateConfig.upsertWhenEmpty': 'mail',
    'v1.emailTemplateConfig.updateWhenEmpty': 'mail',
    'v1.emailTemplateConfig.update': 'mail',
    'v1.mailEventsource.cleanUpOldEvents': 'mail',
    'v1.mailEventsource.undoEvent': 'mail',
    'v1.mailEventsource.reEmit': 'mail',
};
